// extracted by mini-css-extract-plugin
export default {"mainLayout":"Layout_mainLayout__eykyu","mainContent":"Layout_mainContent__LRPMB"};